export default __webpack_public_path__ + "static/media/add-user-icon.3e043a65.svg";